import React from "react";

export default function Clipboard() {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="20.5" height="26.5" viewBox="0 0 20.5 26.5">
      <g
        id="Icons_Line_Copy_to_clipboard"
        data-name="Icons / Line / Copy to clipboard"
        transform="translate(0.75 0.75)"
      >
        <path
          id="Path"
          d="M19,21.8V25H0V0H19V21.8Z"
          fill="none"
          stroke="#000"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeMiterlimit="10"
          strokeWidth="1.5"
        />
        <path
          id="Path-2"
          data-name="Path"
          d="M0,0V1.717A1.254,1.254,0,0,0,1.223,3H5.777A1.254,1.254,0,0,0,7,1.717V0"
          transform="translate(6)"
          fill="none"
          stroke="#000"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeMiterlimit="10"
          strokeWidth="1.5"
        />
        <path
          id="Path-3"
          data-name="Path"
          d="M.05,7.936V0"
          transform="translate(9.45 8.532)"
          fill="none"
          stroke="#000"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeMiterlimit="10"
          strokeWidth="1.5"
        />
        <path
          id="Path-4"
          data-name="Path"
          d="M0,.05H7.936"
          transform="translate(5.532 12.45)"
          fill="none"
          stroke="#000"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeMiterlimit="10"
          strokeWidth="1.5"
        />
      </g>
    </svg>
  );
}
